import FormGroupElement from "./FormGroupElement";

class Select extends FormGroupElement {

    render() {
        return (
            <div className="form-group">
                {this.props?.skipLabel !== true && this.createLabel()}
                <select {...this.prepareProps()}>
                    {this.getOptions()}
                </select>
            </div>
        );
    }

    protected prepareProps(): {} | any {
        let props = super.prepareProps();

        props?.basic && delete props.basic;
        props?.items && delete props.items;
        props?.skipLabel && delete props.skipLabel;
        props?.skipTranslate && delete props.skipTranslate;

        return props;
    }

    private getOptions() {
        let options = [];

        if (this.props?.basic) {
            if (this.props?.skipTranslate) {
                options.push(<option value="" key="basic">{this.props.basic}</option>);
            } else {
                options.push(<option value="" key="basic">{this.dictionary.get[this.props.basic]}</option>);
            }
        }

        if (this.props?.items instanceof Array) {
            if (this.props?.skipTranslate) {
                this.props.items.map((elem) => (
                    options.push(<option key={elem} value={elem}>{elem}</option>)
                ));
            } else {
                this.props.items.map((elem) => (
                    options.push(<option key={elem} value={elem}>{this.dictionary.get[elem]}</option>)
                ));
            }
            return options;
        }

        if (typeof this.props?.items === 'object') {
            if (this.props?.skipTranslate) {
                for (let key in this.props.items) {
                    options.push(<option key={key} value={key}>{this.props.items[key]}</option>);
                }
            } else {
                for (let key in this.props.items) {
                    options.push(<option key={key} value={key}>{this.dictionary.get[this.props.items[key]]}</option>);
                }
            }
        }

        return options;
    }
}

export default Select;
